import { type Lockable, lockOf } from "@auger/core/collections"
import type { AugerField } from "@auger/core/fields"

/** A record field that reads only on a locked record's row: the database
 *  refuses every write to it, so its cell, card and bulk edit are not offered.
 *  `recordOf` finds the row's record (the item itself, or an entry's record). */
export function readOnlyWhenLocked(
  field: AugerField,
  recordOf: (item: unknown) => unknown
): AugerField {
  const editableFor = field.isEditableFor
  return {
    ...field,
    isEditableFor: (item) =>
      !lockOf(recordOf(item) as Lockable).locked && (editableFor?.(item) ?? true),
  }
}
